import Commerce from "@chec/commerce.js";
export const commerce = new Commerce(
  "pk_35166b87e15dd669577fa1dafa223f454624cf8b1664e",
  true
);
